export type VersionCheckerTranslations = {
  newVersionAvailable: string;
  refresh: string;
};

export const versionCheckerTranslations: VersionCheckerTranslations = {
  newVersionAvailable: 'A new version of the app is available.',
  refresh: 'Refresh',
};
